//src/services/adminProducts.api.js
import { adminApiRequest } from "./adminApi";

export const getAdminProducts = () => {
  return adminApiRequest("/admin/products");
};

export const deleteAdminProduct = (id) => {
  return adminApiRequest(`/admin/products/${id}`, {
    method: "DELETE",
  });
};

export const getAdminProductById = (id) => {
  return adminApiRequest(`/admin/products/${id}`);
};

export const updateAdminProduct = (id, data) => {
  return adminApiRequest(`/admin/products/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
};

export const getAdminCategories = () => {
  return adminApiRequest("/admin/meta/categories");
};

export const getAdminTags = () => {
  return adminApiRequest("/admin/meta/tags");
};

/* ✅ ADD THESE (NEW) */
export const createAdminProduct = (data) => {
  return adminApiRequest("/admin/products", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const createAdminTag = (data) => {
  return adminApiRequest("/admin/meta/tags", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const getAdminCategoriesWithProducts = () => {
  return adminApiRequest("/admin/categories");
};

export const createAdminCategory = (data) => {
  return adminApiRequest("/admin/categories", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const deleteAdminCategory = (id) => {
  return adminApiRequest(`/admin/categories/${id}`, {
    method: "DELETE",
  });
};

export const deleteAdminProductImage = (imageId) => {
  return adminApiRequest(`/admin/product-images/${imageId}`, {
    method: "DELETE",
  });
};

export const makeProductsOnSale = (productIds, percent) => {
  return adminApiRequest("/admin/products/make-sale", {
    method: "POST",
    body: JSON.stringify({
      productIds,
      sale_percent: percent,
    }),
  });
};

export const removeProductsFromSale = (productIds) => {
  return adminApiRequest("/admin/products/remove-sale", {
    method: "POST",
    body: JSON.stringify({ productIds }),
  });
};

export const toggleAdminProductVisibility = (id) => {
  return adminApiRequest(`/admin/products/${id}/toggle-visibility`, {
    method: "POST",
  });
};

// Bulk unflag products without deleting or changing any other product fields.
export const bulkRemoveProductFlag = (productIds, filterType) => {
  const endpoint = filterType === "new" ? "remove-new-in" :
    filterType === "bestseller" ? "remove-bestseller" : null;
  if (!endpoint) return Promise.reject(new Error("Unsupported product list"));
  return adminApiRequest(`/admin/products/${endpoint}`, {
    method: "POST",
    body: JSON.stringify({ productIds }),
  });
};
